export async function gestionPDFNodePrive (elementClone) {
  elementClone.childNodes[1].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[2].style.display = 'none'
  elementClone.childNodes[1].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[3].style.display = 'block'
  elementClone.childNodes[1].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[4].style.display = 'none'
  return elementClone
}

export async function gestionPDF (elementClone, univers, metier, annonceParente) {
  // Taille du texte
  if (univers !== 'VO') {
    elementClone.style.fontSize = '10px'
    // Taille du titre principal
    if (elementClone.firstChild && elementClone.firstChild.childNodes[0]) {
      elementClone.firstChild.childNodes[0].style.fontSize = '16px'
    }
  }

  if (univers == 'IMMO' && annonceParente != null) {
    // Agence/CMI & Lot
    if (elementClone.lastElementChild.childNodes[0] && elementClone.lastElementChild.childNodes[0].childNodes[1] && elementClone.lastElementChild.childNodes[0].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[0].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[1] && elementClone.lastElementChild.childNodes[1].childNodes[1] && elementClone.lastElementChild.childNodes[1].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[1].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[2] && elementClone.lastElementChild.childNodes[2].childNodes[0] && elementClone.lastElementChild.childNodes[2].childNodes[0].style) {
      elementClone.lastElementChild.childNodes[2].childNodes[0].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[3] && elementClone.lastElementChild.childNodes[3].childNodes[1] && elementClone.lastElementChild.childNodes[3].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[3].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[5] && elementClone.lastElementChild.childNodes[5].childNodes[1] && elementClone.lastElementChild.childNodes[5].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[5].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[6] && elementClone.lastElementChild.childNodes[6].childNodes[0] && elementClone.lastElementChild.childNodes[6].childNodes[0].style) {
      elementClone.lastElementChild.childNodes[6].childNodes[0].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[9] && elementClone.lastElementChild.childNodes[9].childNodes[1] && elementClone.lastElementChild.childNodes[9].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[9].childNodes[1].style.fontSize = '13px'
    }
    // if (elementClone.lastElementChild.childNodes[10] && elementClone.lastElementChild.childNodes[10].childNodes[0].childNodes[0] && elementClone.lastElementChild.childNodes[10].childNodes[0].childNodes[0].style) {
    //   elementClone.lastElementChild.childNodes[10].childNodes[0].childNodes[0].style.fontSize = '13px'
    // }
  } else if (metier == 'PROMOTEUR' && annonceParente == null) {
    // Promoteur
    if (elementClone.lastElementChild.childNodes[0] && elementClone.lastElementChild.childNodes[0].childNodes[1] && elementClone.lastElementChild.childNodes[0].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[0].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[1] && elementClone.lastElementChild.childNodes[1].childNodes[1] && elementClone.lastElementChild.childNodes[1].childNodes[1].style) {
      elementClone.lastElementChild.childNodes[1].childNodes[1].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[2] && elementClone.lastElementChild.childNodes[2].childNodes[0] && elementClone.lastElementChild.childNodes[2].childNodes[0].style) {
      elementClone.lastElementChild.childNodes[2].childNodes[0].childNodes[0].style.fontSize = '13px'
    }
    if (elementClone.lastElementChild.childNodes[10] && elementClone.lastElementChild.childNodes[10].childNodes[0] && elementClone.lastElementChild.childNodes[10].childNodes[0].style) {
      elementClone.lastElementChild.childNodes[10].childNodes[0].childNodes[0].style.fontSize = '13px'
    }
  }
  return elementClone
}
